import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import * as comps from "./components";
import { AuthGuard } from "@acepteam/globalspack";
import { GroupPortalResolve, GroupPortalUIDataResolve } from "./resolves";
import { MembershipTypeGuard, ChaptersGuard } from "./guards";

const resolveData: any = {
  uidata: GroupPortalUIDataResolve,
  myaccountdata: GroupPortalResolve
};
const routes: Routes = [
  {
    path: "component2",
    component: comps.Component2Component,
    canActivate: [AuthGuard, MembershipTypeGuard],
    resolve: resolveData
  },

  {
    path: "component1",
    component: comps.Component1Component,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "dashboard",
    component: comps.DashboardComponent,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "dashboard/:groupId",
    component: comps.DashboardComponent,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "members",
    component: comps.MembersComponent,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "members/:groupId",
    component: comps.MembersComponent,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "myGroup",
    component: comps.MyGroupComponent,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "myGroup/:groupId",
    component: comps.MyGroupComponent,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "history",
    component: comps.HistoryComponent,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "history/:groupId",
    component: comps.HistoryComponent,
    canActivate: [AuthGuard, ChaptersGuard],
    resolve: resolveData
  },

  {
    path: "checkout",
    component: comps.CheckoutComponent,
    canActivate: [AuthGuard],
    resolve: resolveData
  },

  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full"
  },
  {
    path: "**",
    redirectTo: "dashboard",
    pathMatch: "full"
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupPortalRoutingModule { }
